import { createContext, useContext } from 'react';

// Single shared WebRTC instance for the whole app. WebRTCProvider owns the one useWebRTC()
// (one signaling socket per browser tab); every consumer reads from this context instead of
// calling useWebRTC() again — which previously opened competing sockets (sessions_for_user>1).
export const WebRTCContext = createContext(null);

export const useWebRTCContext = () => {
  const ctx = useContext(WebRTCContext);
  if (!ctx) {
    throw new Error('useWebRTCContext must be used within <WebRTCProvider>');
  }
  return ctx;
};
